import { useLoaderData } from 'react-router'
import { useSelector } from 'react-redux'

import { useTranslate } from '../../utils/translate'
import Link from './Link'

export default function OrderWithdrawalConfirmation() {
  const t = useTranslate('shop', 'components.orderWithdrawalConfirmation')
  const shop = useSelector<State, ImmutableMap>((state) => state.get('shop'))
  const locale = useSelector<State, string | undefined>((state) => state.getIn(['shop', 'locale']))
  const { submittedAt } = useLoaderData<{ submittedAt: string }>()

  const dateAndTime = new Date(submittedAt).toLocaleString(locale, {
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    month: 'numeric',
    year: 'numeric',
  })

  return (
    <>
      <h1>{t('title')}</h1>
      <div className="order-confirmation">
        <div className="order-confirmation-status">
          <div className="status-order">
            <h2>{t('description')}</h2>
            <div className="status-order-email">
              <p>{t('timestamp', { dateAndTime })}</p>
            </div>
          </div>
          <div className="status-home">
            <h2>{t('continueShoppingText')}</h2>
            <Link className="status-home-link" to={shop.get('href')}>
              {t('returnToStartpageLink.label')}
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
